import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

export function usePublicPosts(limit = 10) {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetch = async () => {
      const { data, error } = await supabase
        .from('posts')
        .select('*')
        .eq('status', 'published')
        .order('published_at', { ascending: false })
        .limit(limit)
      if (!error) setPosts(data || [])
      setLoading(false)
    }
    fetch()
  }, [limit])

  return { posts, loading }
}

export function usePublicPost(slug) {
  const [post, setPost] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!slug) return
    const fetch = async () => {
      const { data, error } = await supabase
        .from('posts')
        .select('*')
        .eq('slug', slug)
        .eq('status', 'published')
        .single()
      if (!error) setPost(data)
      setLoading(false)
    }
    fetch()
  }, [slug])

  return { post, loading }
}
